var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 961,
    height: 463,
    viewBox: "0 0 961 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5380_82857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.103 217.522C213.321 217.543 232.687 239.316 232.667 266.178L232.632 312.078L207.132 312.058L207.167 266.158C207.177 252.048 199.195 240.652 185.084 240.64C170.975 240.631 162.976 252.016 162.965 266.126L162.932 312.024L137.433 312.007L137.467 266.107C137.487 239.246 156.883 217.5 185.103 217.522Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.715 291.642C308.824 291.642 320.213 280.251 320.213 266.142C320.213 252.031 308.824 240.641 294.715 240.641C280.604 240.641 269.215 252.031 269.215 266.142C269.215 280.251 280.604 291.642 294.715 291.642ZM344.693 189.642V312.042H320.895V301.162C314.773 309.493 305.084 314.761 294.204 314.761C266.324 314.761 243.715 293.002 243.715 266.142C243.715 239.281 266.324 217.522 294.033 217.522C303.724 217.522 312.393 221.091 319.193 226.871V189.642H344.693Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.866 283.482C540.866 303.202 523.184 314.761 503.464 314.761C483.744 314.761 466.064 303.202 466.064 283.482H491.564C491.564 291.302 497.855 293.342 503.464 293.342C509.075 293.342 515.366 290.453 515.366 284.502C515.366 280.251 509.755 276.342 502.107 275.322C484.256 273.113 467.086 262.231 467.086 247.782C467.086 229.082 483.744 217.522 503.464 217.522C523.184 217.522 539.846 229.082 539.846 248.802H514.344C514.344 240.982 509.075 238.942 503.464 238.942C497.855 238.942 492.584 240.982 492.584 247.102C492.584 252.542 503.806 256.791 513.666 257.982C527.095 259.511 540.866 268.011 540.866 283.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.522 266.142C625.522 252.031 614.133 240.641 600.022 240.641C585.911 240.641 574.523 252.031 574.523 266.142C574.523 280.251 585.911 291.642 600.022 291.642C614.133 291.642 625.522 280.251 625.522 266.142ZM650.001 266.142V312.042H626.203V300.653C620.422 309.151 610.562 314.761 599.513 314.761C571.633 314.761 549.023 293.002 549.023 266.142C549.023 239.281 571.633 217.522 599.513 217.522C627.391 217.522 650.001 239.281 650.001 266.142Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.525 189.642V218.331H713.023V240.09H687.525V266.142C687.525 280.251 698.915 291.642 713.023 291.642V314.761H709.625C681.403 314.761 662.025 293.002 662.025 266.142V189.642H687.525Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.25 240.642C393.31 240.642 382.09 252.032 382.09 266.142C382.09 280.252 393.31 291.642 407.25 291.642C421.19 291.642 432.408 280.252 432.408 266.142C432.408 252.032 421.19 240.642 407.25 240.642ZM407.25 314.762C379.199 314.762 356.59 293.002 356.59 266.142C356.59 239.281 379.199 217.522 407.25 217.522C435.299 217.522 457.91 239.281 457.91 266.142C457.91 293.002 435.299 314.762 407.25 314.762Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.5e-06 0.000108291H960.635V462.363H-2.5e-06V0.000108291Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.384 220.243H125.884V312.043H100.384V220.243ZM127.753 196.443C127.753 204.601 121.125 211.061 113.133 211.061C104.973 211.061 98.516 204.601 98.516 196.443C98.516 188.452 104.973 181.821 113.133 181.821C121.125 181.821 127.753 188.452 127.753 196.443Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.285 126.402C845.584 137.7 851.398 152.371 851.85 167.174C866.098 150.984 865.534 126.316 850.072 110.852C834.685 95.4645 810.18 94.8258 793.988 108.858C808.629 109.42 823.106 115.224 834.285 126.402Z",
    fill: "#FFCB04"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M749.041 211.645C737.863 200.468 732.06 185.991 731.497 171.348C717.465 187.541 718.104 212.045 733.491 227.432C748.956 242.896 773.624 243.46 789.812 229.211C775.011 228.759 760.34 222.944 749.041 211.645Z",
    fill: "#33BCAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M733.491 169.142C732.763 169.87 732.105 170.641 731.443 171.409C732.019 186.03 737.877 200.482 749.04 211.645C760.328 222.933 774.977 228.791 789.765 229.254C790.444 228.659 791.133 228.081 791.781 227.433C807.877 211.337 807.877 185.239 791.781 169.142C775.685 153.046 749.588 153.046 733.491 169.142Z",
    fill: "#C6168D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M776.987 227.424C775.927 227.16 774.866 226.901 773.82 226.579C774.867 226.903 775.926 227.159 776.987 227.424Z",
    fill: "#ED1C24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M782.603 228.55C781.496 228.384 780.391 228.216 779.293 227.988C780.391 228.217 781.496 228.384 782.603 228.55Z",
    fill: "#ED1C24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.426 225.741C770.436 225.389 769.442 225.053 768.468 224.649C769.443 225.054 770.435 225.389 771.426 225.741Z",
    fill: "#ED1C24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M791.781 169.143C807.877 185.239 833.976 185.239 850.072 169.143C850.706 168.506 851.309 167.85 851.894 167.183C851.445 152.376 845.586 137.703 834.285 126.402C823.11 115.227 808.641 109.368 794.004 108.803C793.246 109.458 792.501 110.134 791.781 110.852C775.685 126.948 775.685 153.047 791.781 169.143Z",
    fill: "#EC008C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M791.781 110.852C792.481 110.152 793.208 109.495 793.945 108.856C777.766 108.246 761.392 114.051 749.041 126.402C736.68 138.764 730.874 155.156 731.497 171.348C732.142 170.602 732.782 169.851 733.49 169.142C749.588 153.046 775.685 153.046 791.781 169.142C775.685 153.046 775.685 126.948 791.781 110.852Z",
    fill: "#ED1C24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851.853 167.228C851.281 167.879 850.693 168.52 850.071 169.143C833.975 185.239 807.878 185.239 791.781 169.143C807.878 185.239 807.878 211.336 791.781 227.432C791.149 228.064 790.477 228.631 789.813 229.211C805.85 229.701 822.045 223.887 834.285 211.645C846.511 199.419 852.327 183.248 851.853 167.228Z",
    fill: "#ED1C24"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.481 358.633C125.335 357.605 126.797 356.15 127.871 354.266C128.943 352.381 129.479 350.184 129.479 347.67C129.479 345.189 128.951 343.004 127.893 341.12C126.836 339.236 125.389 337.781 123.549 336.754C121.712 335.728 119.657 335.214 117.391 335.214C115.093 335.214 113.016 335.72 111.163 336.73C109.308 337.742 107.837 339.198 106.749 341.098C105.663 342.997 105.119 345.189 105.119 347.67C105.119 350.184 105.655 352.381 106.728 354.266C107.799 356.15 109.263 357.605 111.117 358.633C112.969 359.661 115.031 360.173 117.299 360.173C119.565 360.173 121.625 359.661 123.481 358.633ZM108.657 362.31C106.084 360.916 104.061 358.946 102.591 356.404C101.12 353.861 100.384 350.949 100.384 347.67C100.384 344.392 101.12 341.481 102.591 338.937C104.061 336.393 106.084 334.417 108.657 333.008C111.231 331.6 114.112 330.894 117.299 330.894C120.485 330.894 123.365 331.6 125.94 333.008C128.513 334.417 130.536 336.393 132.008 338.937C133.477 341.481 134.213 344.392 134.213 347.67C134.213 350.949 133.477 353.861 132.008 356.404C130.536 358.946 128.513 360.916 125.94 362.31C123.365 363.704 120.485 364.401 117.299 364.401C114.112 364.401 111.231 363.704 108.657 362.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.652 358.633C169.505 357.605 170.968 356.15 172.041 354.266C173.113 352.381 173.649 350.184 173.649 347.67C173.649 345.189 173.121 343.004 172.065 341.12C171.008 339.236 169.56 337.781 167.721 336.754C165.883 335.728 163.829 335.214 161.563 335.214C159.264 335.214 157.187 335.72 155.335 336.73C153.479 337.742 152.009 339.198 150.921 341.098C149.833 342.997 149.291 345.189 149.291 347.67C149.291 350.184 149.825 352.381 150.899 354.266C151.969 356.15 153.433 357.605 155.288 358.633C157.141 359.661 159.201 360.173 161.469 360.173C163.736 360.173 165.797 359.661 167.652 358.633ZM152.828 362.31C150.255 360.916 148.233 358.946 146.761 356.404C145.291 353.861 144.556 350.949 144.556 347.67C144.556 344.392 145.291 341.481 146.761 338.937C148.233 336.393 150.255 334.417 152.828 333.008C155.401 331.6 158.283 330.894 161.469 330.894C164.656 330.894 167.536 331.6 170.111 333.008C172.684 334.417 174.707 336.393 176.179 338.937C177.649 341.481 178.384 344.392 178.384 347.67C178.384 350.949 177.649 353.861 176.179 356.404C174.707 358.946 172.684 360.916 170.111 362.31C167.536 363.704 164.656 364.401 161.469 364.401C158.283 364.401 155.401 363.704 152.828 362.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.007 347.073C204.061 347.073 205.693 346.592 206.903 345.625C208.113 344.66 208.718 343.228 208.718 341.328C208.718 339.244 208.129 337.758 206.949 336.869C205.769 335.981 204.123 335.537 202.007 335.537H194.562V347.073H202.007ZM189.874 331.584H202.79C206.221 331.584 208.857 332.41 210.695 334.065C212.534 335.72 213.453 338.141 213.453 341.328C213.453 343.688 212.823 345.686 211.569 347.325C210.313 348.966 208.535 350.076 206.237 350.657L213.314 363.712H208.443L201.594 351.025H194.562V363.712H189.874V331.584Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.945 331.583H246.133V335.537H229.633V345.694H241.95V349.601H229.633V359.805H246.133V363.711H224.945V331.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.045 359.805C271.336 359.805 274.553 358.747 276.699 356.633C278.843 354.519 279.915 351.469 279.915 347.486C279.915 343.809 278.865 340.899 276.768 338.753C274.668 336.61 271.673 335.537 267.783 335.537H262.081V359.805H267.045ZM257.395 331.583H267.736C271.197 331.583 274.2 332.226 276.744 333.514C279.288 334.801 281.24 336.639 282.604 339.029C283.968 341.419 284.649 344.239 284.649 347.486C284.649 352.818 283.111 356.857 280.031 359.598C276.952 362.339 272.637 363.711 267.092 363.711H257.395V331.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.317 358.633C320.171 357.605 321.633 356.15 322.707 354.266C323.779 352.381 324.315 350.184 324.315 347.67C324.315 345.189 323.787 343.004 322.731 341.12C321.673 339.236 320.225 337.781 318.387 336.754C316.548 335.728 314.495 335.214 312.228 335.214C309.929 335.214 307.852 335.72 306 336.73C304.144 337.742 302.675 339.198 301.585 341.098C300.499 342.997 299.956 345.189 299.956 347.67C299.956 350.184 300.491 352.381 301.564 354.266C302.635 356.15 304.099 357.605 305.953 358.633C307.807 359.661 309.867 360.173 312.135 360.173C314.401 360.173 316.463 359.661 318.317 358.633ZM303.493 362.31C300.92 360.916 298.899 358.946 297.427 356.404C295.956 353.861 295.221 350.949 295.221 347.67C295.221 344.392 295.956 341.481 297.427 338.937C298.899 336.393 300.92 334.417 303.493 333.008C306.068 331.6 308.948 330.894 312.135 330.894C315.321 330.894 318.203 331.6 320.776 333.008C323.349 334.417 325.372 336.393 326.844 338.937C328.315 341.481 329.049 344.392 329.049 347.67C329.049 350.949 328.315 353.861 326.844 356.404C325.372 358.946 323.349 360.916 320.776 362.31C318.203 363.704 315.321 364.401 312.135 364.401C308.948 364.401 306.068 363.704 303.493 362.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.488 358.633C364.343 357.605 365.804 356.15 366.877 354.266C367.949 352.381 368.487 350.184 368.487 347.67C368.487 345.189 367.957 343.004 366.901 341.12C365.844 339.236 364.396 337.781 362.557 336.754C360.719 335.728 358.665 335.214 356.399 335.214C354.1 335.214 352.023 335.72 350.171 336.73C348.316 337.742 346.845 339.198 345.757 341.098C344.671 342.997 344.127 345.189 344.127 347.67C344.127 350.184 344.663 352.381 345.735 354.266C346.807 356.15 348.269 357.605 350.125 358.633C351.977 359.661 354.039 360.173 356.305 360.173C358.572 360.173 360.633 359.661 362.488 358.633ZM347.665 362.31C345.091 360.916 343.069 358.946 341.597 356.404C340.127 353.861 339.392 350.949 339.392 347.67C339.392 344.392 340.127 341.481 341.597 338.937C343.069 336.393 345.091 334.417 347.665 333.008C350.239 331.6 353.12 330.894 356.305 330.894C359.492 330.894 362.373 331.6 364.948 333.008C367.52 334.417 369.544 336.393 371.015 338.937C372.485 341.481 373.22 344.392 373.22 347.67C373.22 350.949 372.485 353.861 371.015 356.404C369.544 358.946 367.52 360.916 364.948 362.31C362.373 363.704 359.492 364.401 356.305 364.401C353.12 364.401 350.239 363.704 347.665 362.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.152 331.583H412.841V345.371H429.617V331.583H434.304V363.711H429.617V349.325H412.841V363.711H408.152V331.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.841 361.022C447.604 358.772 446.485 355.666 446.485 351.716V331.584H451.173V351.898C451.173 354.628 451.938 356.686 453.472 358.081C455.004 359.476 457.102 360.173 459.768 360.173C462.404 360.173 464.486 359.476 466.02 358.081C467.552 356.686 468.317 354.628 468.317 351.898V331.584H473.006V351.716C473.006 355.637 471.888 358.733 469.65 361C467.414 363.268 464.12 364.401 459.768 364.401C455.385 364.401 452.077 363.274 449.841 361.022Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.321 335.537H483.348V331.583H508.029V335.537H498.055V363.711H493.321V335.537Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 0.000108291H960.635V462.363H6.10352e-05V0.000108291Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M523.334 362.332C520.76 360.955 518.753 359 517.313 356.471C515.872 353.944 515.153 351.011 515.153 347.671C515.153 344.33 515.872 341.39 517.313 338.846C518.753 336.302 520.76 334.342 523.334 332.962C525.908 331.583 528.85 330.895 532.16 330.895C536.572 330.895 540.264 332.012 543.237 334.25V338.752C540.57 336.394 537.017 335.214 532.573 335.214C530.09 335.214 527.892 335.72 525.977 336.731C524.061 337.743 522.569 339.19 521.496 341.075C520.422 342.959 519.888 345.159 519.888 347.671C519.888 350.184 520.43 352.39 521.52 354.29C522.605 356.19 524.108 357.643 526.024 358.655C527.938 359.667 530.121 360.174 532.573 360.174C534.841 360.174 536.869 359.874 538.664 359.276C540.457 358.679 542.117 357.722 543.65 356.404V360.955C540.893 363.251 537.062 364.402 532.16 364.402C528.85 364.402 525.908 363.711 523.334 362.332Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M555.142 331.583H559.83V345.371H576.607V331.583H581.294V363.711H576.607V349.325H559.83V363.711H555.142V331.583Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.5e-06 0.000108291H960.635V462.363H-2.5e-06V0.000108291Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.704 331.584H598.439V363.712H593.704V331.584Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.317 363.918C612.525 363.598 611.061 363.161 609.928 362.609V358.381C612.869 359.758 616.04 360.448 619.443 360.448C624.223 360.448 626.612 358.838 626.612 355.622C626.612 354.52 626.351 353.63 625.831 352.956C625.311 352.282 624.56 351.692 623.577 351.186C622.597 350.681 621.005 349.984 618.797 349.096C615.765 347.87 613.572 346.521 612.225 345.052C610.877 343.58 610.204 341.726 610.204 339.49C610.204 337.804 610.663 336.31 611.581 335.008C612.503 333.706 613.789 332.694 615.444 331.974C617.097 331.256 618.999 330.894 621.143 330.894C622.889 330.894 624.467 331.032 625.877 331.308C627.287 331.584 628.665 332.028 630.013 332.641V336.686C627.347 335.49 624.651 334.892 621.924 334.892C619.717 334.892 618.032 335.29 616.867 336.088C615.704 336.885 615.121 338.018 615.121 339.49C615.121 340.5 615.375 341.35 615.88 342.04C616.387 342.729 617.135 343.342 618.132 343.878C619.128 344.414 620.607 345.081 622.567 345.878C624.743 346.768 626.457 347.609 627.716 348.405C628.971 349.202 629.928 350.176 630.589 351.326C631.245 352.473 631.576 353.906 631.576 355.622C631.576 358.41 630.58 360.572 628.588 362.104C626.596 363.636 623.655 364.401 619.763 364.401C617.924 364.401 616.111 364.24 614.317 363.918Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.245 358.633C667.099 357.605 668.561 356.15 669.634 354.266C670.707 352.381 671.243 350.184 671.243 347.67C671.243 345.189 670.715 343.004 669.658 341.12C668.601 339.236 667.153 337.781 665.314 336.754C663.475 335.728 661.422 335.214 659.155 335.214C656.857 335.214 654.781 335.72 652.927 336.73C651.073 337.742 649.601 339.198 648.514 341.098C647.426 342.997 646.883 345.189 646.883 347.67C646.883 350.184 647.418 352.381 648.491 354.266C649.563 356.15 651.026 357.605 652.881 358.633C654.735 359.661 656.794 360.173 659.062 360.173C661.329 360.173 663.39 359.661 665.245 358.633ZM650.422 362.31C647.847 360.916 645.826 358.946 644.354 356.404C642.883 353.861 642.149 350.949 642.149 347.67C642.149 344.392 642.883 341.481 644.354 338.937C645.826 336.393 647.847 334.417 650.422 333.008C652.994 331.6 655.875 330.894 659.062 330.894C662.249 330.894 665.13 331.6 667.705 333.008C670.277 334.417 672.301 336.393 673.771 338.937C675.242 341.481 675.977 344.392 675.977 347.67C675.977 350.949 675.242 353.861 673.771 356.404C672.301 358.946 670.277 360.916 667.705 362.31C665.13 363.704 662.249 364.401 659.062 364.401C655.875 364.401 652.994 363.704 650.422 362.31Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_5380_82857",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 961,
    height: 463
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000108291H960.635V462.363H0V0.000108291Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_5380_82857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.469 331.583H691.926L708.289 355.805V331.583H713.023V363.711H708.519L692.157 339.49V363.711H687.469V331.583Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5380_82857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 960.635,
    height: 462.363,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.e6aa94d6bbc254408e19c7e870b75469.svg";
export { ForwardRef as ReactComponent };